import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { HeaderContainer, HeaderContent, Logo, LogoImage } from '../styles';

const Header: React.FC = () => {
  const navigate = useNavigate();
  
  const handleHeaderClick = () => {
    navigate('/');
    window.scrollTo(0, 0);
  };
  
  const handleLogoLinkClick = () => {
    window.scrollTo(0, 0);
  };
  
  return (
    <HeaderContainer onClick={handleHeaderClick}>
      <HeaderContent>
        <Logo>
          <Link to="/" onClick={handleLogoLinkClick}>
            <LogoImage src="/images/header.svg" alt="アラヨットラベル" />
          </Link>
        </Logo>
      </HeaderContent>
    </HeaderContainer>
  );
};

export default Header; 